export const PRODUCT_TYPES = {
  CREDIT_LINE: 'CREDIT_LINE',
  INSTALLMENT: 'INSTALLMENT',
  SACC: 'SACC',
  MACC: 'MACC'
};
